import { styled, CSS } from "@/stitches/config"

const fontSizeLineHeightMap: { [key: string]: string } = {
  12: "16px",
  14: "20px",
  16: "24px",
  20: "28px",
  24: "32px",
  32: "40px",
  64: "72px",
}

const getScaleVariantStyles = (fontSize: number) => {
  const lineHeight = fontSizeLineHeightMap[fontSize]

  return {
    fontSize,
    lineHeight,
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const scaleVariantMap: any = {
  0: {
    ...getScaleVariantStyles(64),
    // "@sm": getScaleVariantStyles(64),
  },
  2: {
    ...getScaleVariantStyles(32),
  },
  4: {
    ...getScaleVariantStyles(24),
  },
  6: {
    ...getScaleVariantStyles(20),
  },
  8: {
    ...getScaleVariantStyles(16),
  },
  10: {
    ...getScaleVariantStyles(14),
  },
  12: {
    ...getScaleVariantStyles(12),
  },
}

const trackingVariant = {
  tight: { letterSpacing: 0 },
  normal: { letterSpacing: "0.5px" },
  wide: { letterSpacing: "1.5px" },
  wider: { letterSpacing: "2px" },
}

export const commonVariants = {
  scale: {
    0: {},
    2: {},
    4: {},
    6: {},
    8: {},
    10: {},
    12: {},
  },
  tracking: trackingVariant,
}

export type TypographyScale = keyof typeof commonVariants.scale

export const Text = styled("p", {
  wordBreak: "break-word",

  variants: {
    ...commonVariants,

    lineBreak: {
      true: {
        whiteSpace: "pre-wrap",
      },
    },
  },

  compoundVariants: [
    ...Object.keys(scaleVariantMap).reduce<
      {
        scale: TypographyScale
        css: CSS
      }[]
    >((acc, scale) => {
      acc.push({
        scale: Number(scale) as TypographyScale,
        css: scaleVariantMap[scale],
      })
      return acc
    }, []),
  ],
})
